import type { QueryClient } from '@tanstack/react-query'

export function invalidateOrgUsers(
  queryClient: QueryClient,
  orgId: string,
): Promise<void> {
  return queryClient.invalidateQueries({
    queryKey: ['api', 'v3', 'orgs', orgId, 'users'],
  })
}
